export default __webpack_public_path__ + "static/media/colored_horse.8f8ec2b7.jpg";